import { z } from 'zod';
/**
 * Hợp đồng API của module `users` — Giám đốc quản lý tài khoản.
 *
 * Các schema CỐ Ý lỏng (chuỗi có trần độ dài, thiếu thì coi như rỗng): chức vụ sai, phòng
 * không có, mật khẩu yếu… đều do service xét THEO ĐÚNG THỨ TỰ của hệ thống cũ và trả về câu
 * báo tiếng Việt tương ứng. Siết bằng `z.enum` ở đây thì người dùng chỉ còn nhận được một câu
 * chung chung «Dữ liệu gửi lên không hợp lệ».
 */
const roleField = z.string().max(32).default('');
const orgUnitIdField = z.string().max(64).default('');
const passwordField = z.string().max(256).default('');
export const userParamsSchema = z.object({ username: z.string().max(64) });
export const createUserRequestSchema = z.object({
    username: z.string().max(64).default(''),
    /** Bỏ trống → lấy luôn tên đăng nhập làm tên hiển thị. */
    displayName: z.string().max(200).default(''),
    password: passwordField,
    role: roleField,
    departmentId: orgUnitIdField,
    teamId: orgUnitIdField,
});
export const approveUserRequestSchema = z.object({
    role: roleField,
    departmentId: orgUnitIdField,
    teamId: orgUnitIdField,
});
/**
 * PATCH đúng nghĩa: trường nào vắng mặt thì giữ nguyên giá trị đang lưu.
 *   displayName                  → đổi tên hiển thị (thêm 29/09/2026; KHÔNG cắt phiên)
 *   role / departmentId / teamId → xếp lại chức vụ (cắt phiên của người đó)
 *   extraDepartmentIds           → phòng KIÊM đứng đầu (thêm 29/09/2026; cắt phiên — đổi phạm vi nhìn)
 *   isActive                     → bật / tắt tài khoản
 */
export const updateUserRequestSchema = z
    .object({
    /** Bỏ trống → lấy tên đăng nhập, như lúc tạo tài khoản. */
    displayName: z.string().max(200).optional(),
    role: z.string().max(32).optional(),
    departmentId: z.string().max(64).optional(),
    teamId: z.string().max(64).optional(),
    /** Toàn bộ danh sách phòng kiêm (thay hẳn, không cộng dồn); mảng rỗng = thôi kiêm. */
    extraDepartmentIds: z.array(z.string().max(64)).max(20).optional(),
    isActive: z.boolean().optional(),
})
    .refine((body) => Object.values(body).some((value) => value !== undefined), {
    message: 'Phải có ít nhất một trường cần đổi',
});
export const resetPasswordRequestSchema = z.object({ password: passwordField });
/** Số liệu người bị xoá đã nhập: xoá luôn, hay chuyển cho tài khoản khác. */
export const RECORD_DISPOSITIONS = ['delete', 'transfer'];
/** Tham số query của `DELETE /users/:username`. */
export const deleteUserQuerySchema = z.object({
    records: z.enum(RECORD_DISPOSITIONS).optional(),
    transferTo: z.string().max(64).default(''),
});
//# sourceMappingURL=users.js.map